import React from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import {DrawerContainer} from './StyledRightSideDrawer';

const drawerVariants = {
  hidden: { x: '100%', opacity: 0, filter: 'blur(10px)' },
  visible: { x: 0, opacity: 1, filter: 'blur(0px)' },
};

const RightSideDrawer = ({
  boxShadow = '-2px 0 8px rgba(0,0,0,0.1)',
  open,
  width = '430px',
  top = '0px',
  children,
  ...rest
}) => (
  <AnimatePresence>
    <DrawerContainer
      boxShadow={boxShadow}
      width={width}
      top={top}
      initial='hidden'
      animate={open ? 'visible' : 'hidden'}
      exit='hidden'
      variants={drawerVariants}
      transition={{ duration: 0.25, ease: 'linear' }}
      {...rest}
    >
      {children}
    </DrawerContainer>
  </AnimatePresence>
);

RightSideDrawer.propTypes = {
  boxShadow: PropTypes.any,
  open: PropTypes.bool.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
}

export default RightSideDrawer;

